import React from 'react';

export class UserInterfaceHints {
    static readonly ADDITIONAL_GAIN_SHOWN = 'additionalGainShown';
    static readonly RESULTS_CHART_VIEW = 'resultsChartView';
}

export interface UserInterfaceHintsStore {

    hints: Set<string>;
    setHints: (hints: Set<string>) => void;
    hasHint: (hint: string) => boolean;
    addHint: (hint: string) => void;
    removeHint: (hint: string) => void;

}



const emptyStore: UserInterfaceHintsStore = {
    hints: new Set<string>(),
    setHints: (_hints: Set<string>) => { return; },
    hasHint: (_hint: string) => { return false; },
    addHint: (_hint: string) => { return; },
    removeHint: (_hint: string) => { return; }
}

export class UserInterfaceHintsStateStore implements UserInterfaceHintsStore {

    hints: Set<string>;
    setHints: (hints: Set<string>) => void;

    constructor(
        hints: Set<string>,
        setHints: (hints: Set<string>) => void
    ) {
        this.hints = hints;
        this.setHints = setHints;
    }

    hasHint(hint: string) {
        return this.hints.has(hint);
    }

    addHint(hint: string) {
        const newHints = new Set(this.hints);
        if (!newHints.has(hint)) {
            newHints.add(hint);
            this.setHints(newHints);
        }
    }

    removeHint(hint: string) {
        const newHints = new Set(this.hints);        
        if (newHints.has(hint)) {
            newHints.delete(hint);
            this.setHints(newHints);
        }
    }

}

export const UserInterfaceHintsContext = React.createContext<UserInterfaceHintsStore>(emptyStore);
